/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { ActionButtonProps, colors } from '@blend/consumer-components';
import { ActionButton } from '@components/ActionButton/ActionButton';

export namespace DefaultSubmitInput {
  export interface Props extends Omit<ActionButtonProps, 'color'> {
    color?: string;
  }
}

export const DefaultSubmitInput: React.FC<DefaultSubmitInput.Props> = ({ children, ...otherProps }) => {
  return (
    <ActionButton data-dd-privacy="allow" type="submit" color={otherProps.color || colors.catalyst} {...otherProps}>
      {children}
    </ActionButton>
  );
};
